var PubSub = require("underpub-js");

var threeUpVideos = function(options) {
  this.options = {
    $el: false,
  };

  $.extend(true, this.options, options);
};

threeUpVideos.prototype.init = function() {
  var self = this;

  this.options.$el
    .find(".video-item .video-image, .video-item .title")
    .on("click", function() {
      var videoUrl = $(this)
        .closest(".video-item")
        .data("videoUrl");

      PubSub.publish("modalVideo:show", videoUrl);
    });

  this.options.$el.find(".video-item").each(function() {
    var $thisVideoItem = $(this);

    var vimeoUrlArray = $(this)
      .data("videoUrl")
      .split("/");
    var vimeoId = vimeoUrlArray[vimeoUrlArray.length - 1];

    $.ajax({
      type: "GET",
      url: "//vimeo.com/api/v2/video/" + vimeoId + ".json"
    }).done(function(data){
			var thumbnail_src = data[0].thumbnail_large;
			$thisVideoItem.find(".video-image img").attr("src", thumbnail_src);
		});

  });
};

module.exports = threeUpVideos;
